module.exports = __webpack_public_path__ + "img/sn.8487b81b.svg";